import { render, staticRenderFns } from "./passengerAccordion.vue?vue&type=template&id=d502311c"
import script from "./passengerAccordion.vue?vue&type=script&lang=js"
export * from "./passengerAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports